const informationTextDataset=[
    {informationCode: "EmailSent", title: "Email Has Been Sent", 
        text:  "Thank you for your email!  We review the email box "+
            "regularly and, if you have requested a response and included " +
            "your email address, will reply soon."},
    {informationCode: "SignonEmail", title: "Request For Access Submitted", 
        text:  "Thank you for requesting access to the MoneyTrain game! " +
            " We review these requests regularly and will reply soon."},
    {informationCode: "GameFeedback", title: "Game Feedback Submitted",
        text: "Thank you for completing the feedback for the MoneyTrain " +
            "game.  Your feedback is important and will likely help us " +
            "to improve the game."},
    {informationCode: "EndGame", title: "Game Ended Successfully",
        text: "Your game has ended...  thanks for playing!!! " +
        "Click on the 'Game' button if you want to start a new game."},
    {informationCode: "UnlockedFeature", title: "Setup Complete",
        text: "Well done! The setup has been completed successfully."
    },
    {informationCode: "PayCreditCard", title: "Payment Successful",
        text: "Your credit card payment has been received."
    },
    {informationCode: "CancelPendingJob", title: "Pending Job Cancelled",
        text: "The Pending Job has been cancelled.  You can choose another " +
         "job or just return to the GameBoard to continue playing with your " +
         "current job."
    },
    {informationCode: "HomeSame", title: "Home Choice Invalid",
        text: "The home/roommates you selected is the same as your current " +
            "home/roommates.  Please make another choice or return to the game."
    },
    {informationCode: "GameChangeComplete", title: "Game Change Complete",
        text: "Good job!! The change has been fully processed.  " +
                    "Review changes to current cash and expenses. " +
                    "Then click on the Close button to continue playing the game."
    },
    {informationCode: "AccountSettingsUpdated", title: "Account Settings Updated",
        text: "Good job!! The account settings have been changed.  "    
    },
    {informationCode: "UserAccountUpdated", title: "User Information Updated",
        text: "Good news!! The class/family code has been changed.  "    
    },
    {informationCode: "RedirectToTest", title: "Redirecting to the Financial Literacy Test",
        text: "Before you play the game, please take a minute to complete the " +
            "short Financial Literacy test.  Good Luck!!  "    
    },
    {informationCode: "NoPlayerGames", title: "No Player Games",
        text: "Currently there are no players that have active games for this account."    
    },
    {informationCode: "createClass", title: "Create New Class",
        text: "Good news!!  The new class has been created."    
    },
    {informationCode: "accountProfile", title: "Class/Household Change",
        text: "Good news!!  The class/household basic information has been changed."    
    },
]

export default informationTextDataset;